import { render, staticRenderFns } from "./DefectStatView.vue?vue&type=template&id=7fc48c3a&scoped=true&"
import script from "./DefectStatView.vue?vue&type=script&lang=js&"
export * from "./DefectStatView.vue?vue&type=script&lang=js&"
import style0 from "./DefectStatView.vue?vue&type=style&index=0&id=7fc48c3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc48c3a",
  null
  
)

export default component.exports